module.exports = __webpack_public_path__ + "img/intro_tab2_1.75c16055.png";